/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: dcc64d2b9d0632d606c9c2cb639ce99b329dbe9c601955ba339a8f303306b3a5
 */
import {
  base_colorAction,
  base_contentHover,
  notification_colorAlert,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import {
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_size_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  align-items: flex-start;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  gap: ${spacing(2)};
  padding-block: ${spacing(3)};
  padding-inline: 20px;
  position: relative;
  text-align: left;
  width: 329px;

  .contentRow {
    align-items: flex-start;
    display: flex;
    flex-grow: 1;
    gap: ${spacing(2)};
    min-width: 0;
  }

  .iconWrapper {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    height: 20px;
    justify-content: center;
    width: 20px;
  }

  .aiPill {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    height: 20px;
    justify-content: center;
    width: 20px;
  }

  .textStack {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 4px;
    min-width: 0;
  }

  .title {
    font-size: ${font_size_md};
    font-family: ${font_family_weight_regular};
    line-height: 18px;
    white-space: nowrap;
  }

  .subtext {
    color: ${text_colorTextSecondary};
    font-size: ${font_size_sm};
    font-family: ${font_family_weight_regular};
    line-height: 16px;
    width: 100%;
  }

  .trailingWrapper {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    height: 20px;
    justify-content: center;
    overflow: clip;
    width: 20px;
  }

  &.variant-default {

    &:hover {
      background: ${base_contentHover};
    }
  }

  &.variant-severe {

    &:hover {
      background: ${base_contentHover};
    }
  }

  &.default .iconWrapper,
  &.default .title {
    color: ${base_colorAction};
  }

  &.severe .iconWrapper,
  &.severe .title {
    color: ${notification_colorAlert};
  }
`
